import { render, staticRenderFns } from "./live-item-hot.vue?vue&type=template&id=c2a50432&scoped=true"
import script from "./live-item-hot.vue?vue&type=script&lang=js"
export * from "./live-item-hot.vue?vue&type=script&lang=js"
import style0 from "./live-item-hot.vue?vue&type=style&index=0&id=c2a50432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a50432",
  null
  
)

export default component.exports